import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Popover, Typography, Box } from '@mui/material';

const ConfirmPopup = function ConfirmPopup({
  open = false,
  close = () => {},
  anchorEl = null,
  confirmText = null,
  handleConfirm = () => {},
}) {
  const intl = useIntl();
  return (
    <Popover
      id="confirm-popup"
      open={open}
      anchorEl={anchorEl}
      onClose={close}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <div
        style={{
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '300px',
          height: '150px',
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            alignSelf: 'center',
          }}
        >
          {confirmText || intl.messages.GENERAL_CONFIRMTEXT}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Button onClick={close} variant="text" color="error">
            {intl.messages.CANCEL}
          </Button>
          <Button
            onClick={(e) => {
              close(e);
              handleConfirm(e);
            }}
            variant="text"
          >
            {intl.messages.CONFIRM}
          </Button>
        </Box>
      </div>
    </Popover>
  );
};

export default ConfirmPopup;
